import {
  Box, Stack, Typography, TextField, IconButton, Paper
} from '@mui/material';
import { PhotoCamera, Delete, CloudUpload } from '@mui/icons-material';
import { motion, AnimatePresence } from 'framer-motion';
import { useCallback, useEffect } from 'react'
import { loadURlImgEmpreendimentos } from '../../../api/storage'
import { isUrl } from '../../../utils/validURL'

export const Nuvem = ({
  setPlaceEdit, placeEdit,
  setNewPlace, newPlace, setFileImg, fileImg
}) => {
  // Eliminando o estado nuvem e usando placeEdit diretamente

  async function delImgEmpreeendimento() {
    // Limpar o campo de URL
    const urlImg = document.getElementById('urlimagem')
    if (urlImg) urlImg.value = ''
    
    // Atualizar o estado para remover a imagem
    setPlaceEdit({ ...placeEdit, urlimagem: '', file: null })
    
    // Se ainda houver uma imagem visível, definir uma imagem padrão
    const img = document.getElementById('imgEmp')
    if (img) img.setAttribute('src', 'assets/images/gimov.png')
  }

  // Usando useCallback para evitar recriação da função a cada renderização
  const loadImgEmpreendimento = useCallback(async () => {
    // console.log('loadImgEmpreendimento', placeEdit.urlimagem)
    let _url = ''
    if (placeEdit.urlimagem) {
      if (!isUrl(placeEdit.urlimagem)) {
        // console.log('Não É URL', placeEdit.urlimagem)
        _url = URL.createObjectURL(placeEdit.file)
      }
      else {
        // console.log('É URL', placeEdit.urlimagem)
        if (placeEdit.urlimagem.includes('firebasestorage.googleapis.com')) _url = await loadURlImgEmpreendimentos(newPlace.id)
        else _url = placeEdit.urlimagem
      }
      setPlaceEdit(prevState => ({ ...prevState, urlimagem: _url }))
      if (_url) {
        const img = document.getElementById('imgEmp')
        if (img) img.setAttribute('src', _url)
      }
    }
  }, [placeEdit.urlimagem, placeEdit.file, newPlace.id, setPlaceEdit]);

  useEffect(() => {
    loadImgEmpreendimento()
  }, [loadImgEmpreendimento]);

  function handleLoadImage(event) {
    var _file = event.target.files[0];
    // console.log('handleLoadImage', _file)
    if (!_file) return
    const url = URL.createObjectURL(_file)
    
    // Verificar se a imagem existe e se não existir, criar estado para mostrar a imagem
    if (!placeEdit.urlimagem) {
      // Atualizar o estado para garantir que a imagem seja renderizada
      setPlaceEdit({ ...placeEdit, file: _file, urlimagem: _file.name })
      // Damos tempo para o React renderizar o componente
      setTimeout(() => {
        const img = document.getElementById('imgEmp')
        if (img) img.setAttribute('src', url)
      }, 100)
    } else {
      const img = document.getElementById('imgEmp')
      // console.log('img', img)
      if (img) img.setAttribute('src', url)
      setPlaceEdit({ ...placeEdit, file: _file, urlimagem: _file.name })
    }
  }

  return (
    <Box
      component={motion.div}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      sx={{
        width: '100%',
        p: 0
      }}
    >
      <Stack spacing={3}>
        {/* Image Upload Section */}
        <Paper
          elevation={2}
          sx={{
            p: 2,
            borderRadius: 2,
            bgcolor: 'background.paper'
          }}
        >
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={2}
          >
            {/* Form Fields */}
            <Stack spacing={2} sx={{ flex: 1 }}>
              <Typography variant="h6" color="primary" fontWeight="medium">
                Imagem e Links Principais
              </Typography>

              <TextField
                id='urlimagem'
                fullWidth
                variant="outlined"
                size="small"
                label="URL da Foto do empreendimento"
                value={placeEdit.urlimagem || ''}
                onChange={(e) => setPlaceEdit({ ...placeEdit, urlimagem: e.target.value })}
                helperText="Link da foto do empreendimento do site da construtora"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2
                  }
                }}
              />

              <TextField
                fullWidth
                variant="outlined"
                size="small"
                label="Drive"
                value={placeEdit.drive || ''}
                onChange={(e) => setPlaceEdit({ ...placeEdit, drive: e.target.value })}
                helperText="Link do Drive da construtora"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2
                  }
                }}
              />

              <TextField
                fullWidth
                variant="outlined"
                size="small"
                label="Tabela de Vendas"
                value={placeEdit.tbvendas || ''}
                onChange={(e) => setPlaceEdit({ ...placeEdit, tbvendas: e.target.value })}
                helperText="Pasta TABELA DE VENDAS do drive da construtora"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2
                  }
                }}
              />
            </Stack>

            {/* Image Preview */}
            <Paper
              elevation={1}
              sx={{
                width: { xs: '100%', md: '300px' },
                p: 1,
                borderRadius: 2,
                border: '2px dashed',
                borderColor: 'divider',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <AnimatePresence>
                {/* Renderiza a imagem sempre com id imgEmp, mas alterna entre a imagem ou um ícone */}
                <motion.div
                  key="preview-container"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  style={{
                    width: '100%',
                    height: '200px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  {placeEdit.urlimagem ? (
                    <motion.img
                      key="preview"
                      id="imgEmp"
                      alt="Preview"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        borderRadius: '8px'
                      }}
                    />
                  ) : (
                    <CloudUpload sx={{ fontSize: 64, color: 'text.secondary' }} />
                  )}
                </motion.div>
              </AnimatePresence>

              <Stack
                direction="row"
                spacing={1}
                sx={{ mt: 1 }}
              >
                <IconButton
                  color="error"
                  onClick={delImgEmpreeendimento}
                  size="small"
                >
                  <Delete />
                </IconButton>
                <IconButton
                  color="primary"
                  component="label"
                  size="small"
                >
                  <input
                    hidden
                    accept="image/*"
                    type="file"
                    onChange={handleLoadImage}
                  />
                  <PhotoCamera />
                </IconButton>
              </Stack>
            </Paper>
          </Stack>
        </Paper>

        {/* Additional Links Section */}
        <Paper
          elevation={2}
          sx={{
            p: 2,
            borderRadius: 2,
            bgcolor: 'background.paper'
          }}
        >
          <Stack spacing={2}>
            <Typography variant="h6" color="primary" fontWeight="medium">
              Links Adicionais
            </Typography>

            {[
              { id: 'plantas', label: 'Plantas', helper: 'Pasta PLANTAS do drive da construtora' },
              { id: 'memorial', label: 'Memorial Descritivo', helper: 'Pasta MEMORIAL DESCRITIVO do drive da construtora' },
              { id: 'implantacao', label: 'Implantação', helper: 'Pasta IMPLANTAÇÃO do drive da construtora' },
              { id: 'divulgacao', label: 'Divulgação', helper: 'Pasta DIVULGAÇÃO do drive da construtora' }
            ].map(field => (
              <TextField
                key={field.id}
                fullWidth
                variant="outlined"
                size="small"
                label={field.label}
                value={placeEdit[field.id] || ''}
                onChange={(e) => setPlaceEdit({ ...placeEdit, [field.id]: e.target.value })}
                helperText={field.helper}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2
                  }
                }}
              />
            ))}
          </Stack>
        </Paper>
      </Stack>
    </Box>
  );
};